import { render, staticRenderFns } from "./bbs2down.vue?vue&type=template&id=05b96742&scoped=true"
import script from "./bbs2down.vue?vue&type=script&lang=js"
export * from "./bbs2down.vue?vue&type=script&lang=js"
import style0 from "./bbs2down.vue?vue&type=style&index=0&id=05b96742&prod&lang=less&scoped=true"
import style1 from "./bbs2down.vue?vue&type=style&index=1&id=05b96742&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b96742",
  null
  
)

export default component.exports